import { OwnershipTransferNotification as OwnershipTransferNotificationType } from '../types'
import { BaseNotificationItem } from '../BaseNotificationItem'
import Styles from '../NotificationItem.module.scss'
import { Lock } from 'almanac-ui/icons'
import { articleOrLayerPath } from '../utils'

interface Props {
  notification: OwnershipTransferNotificationType
  onClose: () => void
}

export const OwnershipTransferNotification = ({ notification, onClose }: Props) => {
  const title = 'made you owner'
  const path = articleOrLayerPath({ notification })

  return (
    <BaseNotificationItem
      notification={notification}
      onClose={onClose}
      title={title}
      icon={
        <div role="img" title="Access Icon" className={Styles.icon}>
          <Lock />
        </div>
      }
      path={path}
      aria-label="Ownership Transfer Notification"
    />
  )
}
